import React from 'react';

import ReactComponent from './dam.svg?react';

function FarmbotDamIcon() {
  return <ReactComponent width={18} />;
}

export default FarmbotDamIcon;
